import { render } from "./MessageComposer.vue?vue&type=template&id=7a5c269a&scoped=true&ts=true"
import script from "./MessageComposer.vue?vue&type=script&lang=ts"
export * from "./MessageComposer.vue?vue&type=script&lang=ts"

import "./MessageComposer.vue?vue&type=style&index=0&id=7a5c269a&lang=scss&scoped=true"

import exportComponent from "/Users/TomaccioD/Documents/other/nigma-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5c269a"]])

export default __exports__